import React, { Component } from 'react';
import { Row, Col, Button, Divider, message, Spin, Tag, Alert, Modal } from 'antd';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { Customer, Auth, File as FileApi, Billing } from '../../../../services/api';
import TokenStorage from '../../../../services/TokenStorage';
import CheckoutForm from '../../../../components/CheckoutForm';
import { Format } from '../../../../components/Date';

export default class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: { contact: {}, owner: {} },
            billingDetails: {},
            cardValid: false,
            showDeleteAccount: false,
            loading: {
                customer: false,
                policy: false,
                creditCard: false,
                deleteAccount: false
            },
            policy: {}
        };

        this.customerApi = new Customer(props);
        this.authApi = new Auth(props);
        this.fileApi = new FileApi();
        this.billingApi = new Billing(props);
    }

    componentDidMount() {
        this.fetchMe();
        this.fetchBillingDetails();
    }

    fetchMe = () => {
        const { loading } = this.state;
        loading.customer = true;
        this.setState({ loading });
        this.customerApi.me()
            .then(res => {
                loading.customer = false;
                this.setState({ customer: res.data.data, loading });
                this.fetchPolicy();
            })
            .catch(() => {
                this.customerApi.retry({ cb: this.fetchMe });
                loading.customer = false;
                this.setState({ loading })
            });
    }

    fetchPolicy = () => {
        const { customer, loading } = this.state;
        if (!customer._links.policy) {
            return;
        }

        loading.policy = true;
        this.setState({ loading });
        this.customerApi.raw().get(customer._links.policy.href)
            .then(res => {
                this.downloadPolicy(res.data.data);
            })
            .catch(() => {
                this.customerApi.retry({ cb: this.fetchPolicy });
                loading.policy = false;
                this.setState({ loading });
            })
    }

    fetchBillingDetails = () => {
        this.billingApi.details()
            .then(res => {
                this.setState({ billingDetails: res.data.data });
            })
            .catch(() => {
                this.billingApi.retry({ cb: this.fetchBillingDetails });
            });
    }

    downloadPolicy = (policy) => {
        const { loading } = this.state;
        this.fileApi.download(policy._links.download.href)
            .then(res => {
                loading.policy = false;
                policy.html = res.data;
                this.setState({ loading, policy });
            })
            .catch(() => {
                message.error('Kunde inte ladda måltidspolicy. Prova att ladda om sidan.')
            });
    }

    logout = () => {
        this.authApi.logout()
            .then(() => {
                TokenStorage.removeToken(TokenStorage.TYPE_ID);
                TokenStorage.removeToken(TokenStorage.TYPE_REFRESH);
                this.props.history.push('/');
            })
            .catch(() => {
                TokenStorage.removeToken(TokenStorage.TYPE_ID);
                TokenStorage.removeToken(TokenStorage.TYPE_REFRESH);
                this.props.history.push('/');
            });
    }

    onCardUpdated = () => {
        const { loading } = this.state;
        loading.creditCard = false;
        this.setState({ cardValid: true, loading });
    }

    onCreditCardLoading = () => {
        const { loading } = this.state;
        loading.creditCard = true;
        this.setState({ loading });
    }

    closeAccount = () => {
        this.authApi.closeAccount()
            .then(() => {
                this.logout();
            })
            .catch(() => {
                this.authApi.retry({ cb: this.closeAccount });
            });
    }

    confirmCloseAccount = () => {
        Modal.confirm({
            title: 'Är du säker att du vill avluta kontot?',
            content: 'När du avslutar ditt konto kommer även alla dina sparade menyer att försvinna.',
            onOk: this.closeAccount,
            onCancel: () => this.setState({ showDeleteAccount: false }),
            okButtonProps: { loading: this.state.loading.deleteAccount },
            okText: 'Ja, avsluta kontot',
            cancelText: 'Nej, ta mig härifrån'
        });
    }

    render() {
        const { 
            customer, 
            loading, 
            policy, 
            billingDetails, 
            showCreditCardForm, 
            cardValid
         } = this.state;

        return (
            <Row>
                <Col xs={24} sm={16}>
                    <h3>Måltidspolicy</h3>
                    {loading.policy && (
                        <div style={{ textAlign: 'center', marginTop: '70px' }}>
                            <Spin size="large" />
                        </div>
                    )}

                    {!loading.customer && !loading.policy && !policy.id && (
                        <Alert
                            type="info"
                            showIcon
                            message="Ingen måltidspolicy finns tillgänglig."
                            style={{ width: '70%', marginTop: '30px' }}
                        />
                    )}
                    {!loading.policy && policy.id && (
                        <div>
                            <div style={{ marginBottom: '20px' }}>
                                {policy.tags.map(t => <Tag key={t} color="volcano">{t}</Tag>)}
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: policy.html }} style={{ marginBottom: '20px', paddingRight: '10px' }}></div>
                        </div>
                    )}

                </Col>
                <Col xs={24} sm={8}>
                    <h3>Konto</h3>
                    <p><strong>Email: </strong>{customer.contact.email}</p>
                    {billingDetails && (
                        <div>
                            <p>
                                <strong>Abonnemang: </strong>199kr/mån
                                {billingDetails.trial_period && <span> (testperiod till den: <Format timestamp={billingDetails.trial_period_end} />)</span>}
                            </p>
                            {billingDetails.discount && (
                                <div>
                                    {billingDetails.discount.until > 0 && (
                                        <p><strong>Kampanj: </strong>{`${billingDetails.discount.percentage}%, till den: `} <Format timestamp={billingDetails.discount.until} /></p>
                                    )}
                                    {billingDetails.discount.always_free && (
                                        <p><strong>Kampanj: </strong>Gratis</p>
                                    )}
                                </div>
                                
                            )}
                            <Button icon="credit-card" type="primary" onClick={() => this.setState({ showCreditCardForm: true })}>Ändra betalinformation</Button>
                            <Modal
                                title="Ange betalinformation"
                                visible={showCreditCardForm}
                                closable={false}
                                maskClosable={false}
                                onOk={() => this.setState({ showCreditCardForm: false })}
                                onCancel={() => this.setState({ showCreditCardForm: false })}
                                okButtonProps={{ disabled: !cardValid, loading: loading.creditCard }}
                                cancelText="Avbryt"
                            >
                                {cardValid && (
                                    <Alert
                                        type="success"
                                        message="Din betalinformation har lagts till. Du kan nu börja använda ditt konto."
                                        showIcon
                                        style={{ marginBottom: '20px' }}
                                    />
                                )}
                                <StripeProvider apiKey="pk_test_ZPdN66V614YGjyhg4rQP8I87" locale="se">
                                    <Elements locale="sv">
                                        <CheckoutForm billing={billingDetails} onSuccess={this.onCardUpdated} onLoading={this.onCreditCardLoading} />
                                    </Elements>
                                </StripeProvider>
                            </Modal>
                        </div>
                    )}

                    <Divider />
                    <div>
                        <Button icon="logout" type="danger" onClick={this.logout} style={{ marginRight: '5px' }}>Logga ut</Button>
                        <Button icon="delete" onClick={this.confirmCloseAccount} type="danger">Avsluta konto</Button>
                    </div>
                </Col>
            </Row>
        );
    }
}





// WEBPACK FOOTER //
// ./src/screens/dashboard/components/profile/Profile.js